import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import "./Create_Step5.css";
import Preview_Modal from "../../../common/common-modal/preview-modal/Preview_Modal";

const Create_Step5 = ({ step, totalSteps, setStep }) => {
  // -------- Multiple files --------
  const fileRefs = {
    aadhaarFront: useRef(null),
    aadhaarBack: useRef(null),
    voterId: useRef(null),
    passportDl: useRef(null),
  };

  const [files, setFiles] = useState({
    aadhaarFront: null,
    aadhaarBack: null,
    voterId: null,
    passportDl: null,
  });

  // -------- Single file (Passport photo) --------
  const singleFileRef = useRef(null);
  const [singleFile, setSingleFile] = useState(null);

  // -------- Modal --------
  const [modalShow, setModalShow] = useState(false);
  const [modalFile, setModalFile] = useState(null);

  // -------- Handlers --------
  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [type]: {
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      },
    }));
  };

  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSingleFile({
      file,
      name: file.name,
      preview: URL.createObjectURL(file),
    });
  };

  const openPreviewModal = (file) => {
    setModalFile(file);
    setModalShow(true);
  };

  const handleFileButtonClick = (type) => {
    if (files[type]?.preview) {
      openPreviewModal(files[type]);
    } else {
      fileRefs[type].current.click();
    }
  };

  const handleSingleButtonClick = () => {
    if (singleFile?.preview) {
      openPreviewModal(singleFile);
    } else {
      singleFileRef.current.click();
    }
  };

  return (
    <section className="step3_wrapper step1_wrapper step4_wrapper step5_wrapper">
      <Form_Header
        title="Owner / Authorized Signatory KYC"
        subtitle="(Individual Proofs)"
        step={5}
        totalSteps={6}
      />

      <div className="container mt-4">
        <div className="doc_header">
          <h5 className="doc_title">Proof of Identity</h5>
          <span className="doc_info">(Any 1 ID Proof of the following)</span>
        </div>

        {/* -------- ID Proofs -------- */}
        <div className="row mt-4">
          {[
            { label: "Aadhaar Card (Front)", key: "aadhaarFront" },
            { label: "Aadhaar Card (Back)", key: "aadhaarBack" },
            { label: "Voter ID Card", key: "voterId" },
            { label: "Passport / Driving License", key: "passportDl" },
          ].map((item) => (
            <div className="col-lg-6 mb-4" key={item.key}>
              <Form.Group>
                <Form.Label>{item.label}</Form.Label>

                <div className="file_upload_wrapper">
                  <span className="file_placeholder">
                    {files[item.key]?.name || "No File Uploaded"}
                  </span>

                  <div
                    className="upload_btn"
                    onClick={() => handleFileButtonClick(item.key)}
                  >
                    <Common_Btn
                      btnText={files[item.key] ? "Preview" : "Upload file"}
                    />
                  </div>

                  <input
                    ref={fileRefs[item.key]}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => handleFileChange(item.key, e)}
                  />
                </div>
              </Form.Group>
            </div>
          ))}
        </div>

        {/* -------- Passport Photo -------- */}
        <div className="row">
          <h4 className="passport_title mb-4 mt-4">Passport Size Photo*</h4>

          <div className="col-lg-6 mb-4">
            <Form.Group>
              <Form.Label>Passport Size Photo</Form.Label>

              <div className="file_upload_wrapper">
                <span className="file_placeholder">
                  {singleFile?.name || "No File Uploaded"}
                </span>

                <div className="upload_btn" onClick={handleSingleButtonClick}>
                  <Common_Btn
                    btnText={singleFile ? "Preview" : "Upload file"}
                  />
                </div>

                <input
                  ref={singleFileRef}
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleSingleFileChange}
                />
              </div>
            </Form.Group>
          </div>
        </div>

        {/* -------- Buttons -------- */}
        <div className="form_btn_holder">
          <White_Btn btnText="Back" onClick={() => setStep(4)} />
          <Common_Btn btnText="Next" onClick={() => setStep(6)} />
        </div>
      </div>

      {/* -------- Common Document Modal -------- */}
      <Preview_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        file={modalFile}
        onUploadNew={() => {
          if (modalFile === singleFile) {
            singleFileRef.current.click();
          } else {
            const key = Object.keys(files).find((k) => files[k] === modalFile);
            fileRefs[key]?.current.click();
          }
        }}
        onDelete={() => {
          if (modalFile === singleFile) {
            setSingleFile(null);
          } else {
            const key = Object.keys(files).find((k) => files[k] === modalFile);
            setFiles((prev) => ({ ...prev, [key]: null }));
          }
          setModalShow(false);
        }}
      />
    </section>
  );
};

export default Create_Step5;
